
import BuyerPricingHeader from "./components/pricing/BuyerPricingHeader";
import BuyerPricingHero from "./components/pricing/BuyerPricingHero";
import BuyerPricingPlans from "@/components/buyer/landing/BuyerPricingPlans";
import BuyerPricingFAQ from "./components/pricing/BuyerPricingFAQ";
import BuyerPricingFooter from "./components/pricing/BuyerPricingFooter";
import PageSEO from "@/components/seo/PageSEO";
import StructuredData from "@/components/seo/StructuredData";

const BuyerPricingPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#080c14] text-white">
      <PageSEO
        title="Real Estate Investment Platform Pricing | Find Deals | GoDyspo"
        description="Access wholesale deals for free. Search off-market properties, save searches, and connect with wholesalers — no credit card required."
        canonical="/buyer/pricing"
        keywords="real estate investment platform pricing, wholesale deal finder, off-market property search, investment property deals"
      />
      <StructuredData 
        type="BreadcrumbList" 
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "For Investors", url: "/buyer" },
          { name: "Pricing", url: "/buyer/pricing" }
        ]} 
      />
      <BuyerPricingHeader />

      <section className="py-16 flex-1">
        <div className="container mx-auto px-4">
          <BuyerPricingHero />

          <div className="max-w-5xl mx-auto">
            <BuyerPricingPlans billingPeriod="monthly" />

            <div className="text-center mt-8 text-gray-400">
              Free access to our easy-to-use platform with no hidden fees.
            </div>
          </div>
        </div>
      </section>

      <BuyerPricingFAQ />
      <BuyerPricingFooter />
    </div>
  );
};

export default BuyerPricingPage;
